var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"usage-bar"},[_c('div',{staticClass:"used",style:({
        'background-color': _vm.usageColor,
        width: _vm.usageWidth
      })}),_c('div',{staticClass:"percentage-field"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }